// src/hooks/creator-use-auth.js
import React, {
    createContext,
    useState,
    useContext,
    useCallback,
  } from "react";
  import {
    getAuthInfo,
    setAuthToken,
    removeAuthToken,
  } from "../API/creatorTokenUtil";
  import { clearGoogleSession } from '../Utils/googleSession.ts';

  const CreatorAuthContext = createContext();
  
  /**
   * Provider keeps the creator token in React state and
   * local‑/session‑storage (via *creatorTokenUtil* helpers).
   */
  export const CreatorAuthProvider = ({ children }) => {
    const [creatorToken, setCreatorToken] = useState(getAuthInfo());
  
    /** Save token locally + to storage */
    const login = useCallback((token) => {
      setAuthToken(token);
      setCreatorToken(token);
    }, []);
  
    /** Clear token locally + from storage */
    const logout = useCallback(() => {
      clearGoogleSession();      // --- NEW
      removeAuthToken();
      setCreatorToken(null);
    }, []);
  
    /** Alias so API matches normal `useAuth()` */
    const unauthorize = logout;
  
    /** Convenience: boolean for quick checks */
    const isCreatorAuthorized = Boolean(creatorToken);
  
    return (
      <CreatorAuthContext.Provider
        value={{
          creatorToken,
          isCreatorAuthorized,
          login,
          logout,
          unauthorize,
        }}
      >
        {children}
      </CreatorAuthContext.Provider>
    );
  };
  
  export const useCreatorAuth = () => useContext(CreatorAuthContext);
  